// Version : 0.0.5
// Author : VISHNU
// LastEdit : KARTHEESWARAN
// MODFIED DATA : 13-08-2025
const GSTTypeActionTypes = {
	/** ***************** ADD GST TYPE DETAILS START *********************** */
	ADD_GST_TYPE_DETAILS_START: 'add_gst_type_details_start',
	ADD_GST_TYPE_DETAILS_SUCCESS: 'add_gst_type_details_success',
	ADD_GST_TYPE_DETAILS_FAILURE: 'add_gst_type_details_failure',
	ADD_GST_TYPE_DETAILS_RESPONSE_RESET: 'add_gst_type_details_response_reset',
	ADD_GST_TYPE_DETAILS_RESPONSE_CHANGED: 'add_gst_type_details_response_changed',
	/** ***************** ADD GST TYPE DETAILS END *********************** */

	/** ***************** UPDATE GST TYPE DETAILS START *********************** */
	UPDATE_GST_TYPE_DETAILS_START: 'update_gst_type_details_start',
	UPDATE_GST_TYPE_DETAILS_SUCCESS: 'update_gst_type_details_success',
	UPDATE_GST_TYPE_DETAILS_FAILURE: 'update_gst_type_details_failure',
	UPDATE_GST_TYPE_DETAILS_RESPONSE_RESET: 'update_gst_type_details_response_reset',
	UPDATE_GST_TYPE_DETAILS_RESPONSE_CHANGED: 'update_gst_type_details_response_changed',
	/** ***************** UPDATE GST TYPE DETAILS END *********************** */

	/** ***************** GET GST TYPE LIST START *********************** */
	GET_GST_TYPE_LIST_START: 'get_gst_type_list_start',
	GET_GST_TYPE_LIST_SUCCESS: 'get_gst_type_list_success',
	GET_GST_TYPE_LIST_FAILURE: 'get_gst_type_list_failure',
	GET_GST_TYPE_LIST_RESPONSE_RESET: 'get_gst_type_list_response_reset',
	GET_GST_TYPE_LIST_RESPONSE_CHANGED: 'get_gst_type_list_response_changed',
	/** ***************** GET GST TYPE LIST END *********************** */

	/** ***************** FETCH GST TYPE DETAILS START *********************** */
	FETCH_GST_TYPE_DETAILS_START: 'fetch_gst_type_details_start',
	FETCH_GST_TYPE_DETAILS_SUCCESS: 'fetch_gst_type_details_success',
	FETCH_GST_TYPE_DETAILS_FAILURE: 'fetch_gst_type_details_failure',
	FETCH_GST_TYPE_DETAILS_RESPONSE_RESET: 'fetch_gst_type_details_response_reset',
	FETCH_GST_TYPE_DETAILS_RESPONSE_CHANGED: 'fetch_gst_type_details_response_changed',
	/** ***************** FETCH GST TYPE DETAILS END *********************** */

	/** ***************** DELETE GST TYPE DETAILS START *********************** */
	DELETE_GST_TYPE_DETAILS_START: 'delete_gst_type_details_start',
	DELETE_GST_TYPE_DETAILS_SUCCESS: 'delete_gst_type_details_success',
	DELETE_GST_TYPE_DETAILS_FAILURE: 'delete_gst_type_details_failure',
	DELETE_GST_TYPE_DETAILS_RESPONSE_RESET: 'delete_gst_type_details_response_reset',
	DELETE_GST_TYPE_DETAILS_RESPONSE_CHANGED: 'delete_gst_type_details_response_changed',
	/** ***************** DELETE GST TYPE DETAILS END *********************** */
};

export default GSTTypeActionTypes;
